import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ICustomerQuantity } from 'apis/types';
import { RootState } from 'app/store';

export interface CustomerQuantityState {
  loading: boolean;
  data: number;
}

const initialState: CustomerQuantityState = {
  loading: true,
  data: 0,
};

const customerQuantitySlice = createSlice({
  name: 'customer_quantity',
  initialState,
  reducers: {
    setData(state, action: PayloadAction<number>) {
      state.data = action.payload;
    },
    fetchCustomerQuantityData(state) {
      state.loading = true;
    },
    fetchCustomerQuantityDataSuccess(state, action: PayloadAction<ICustomerQuantity>) {
      state.data = Number(action.payload.data);
      state.loading = false;
    },
    fetchCustomerQuantityDataFailed(state) {
      state.loading = false;
      state.data = 0;
    },
    setCustomerQuantityData(state, action: PayloadAction<number>) {
      state.data = action.payload;
    },
  },
});

// Actions
export const customerQuantityActions = customerQuantitySlice.actions;

// Selectors
export const selectCustomerQuantityLoading = (state: RootState) => state.customerQuantity.loading;
export const selectCustomerQuantity = (state: RootState) => state.customerQuantity.data;

// Reducer
export const customerQuantityReducer = customerQuantitySlice.reducer;
